<template>
  <div>
    <el-input
      ref="reference"
      v-model="input"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="disabled"
      :readonly="readonly"
      @focus="handleFocus"
      @keydown.native="handleKeyDown"
      @clear="handleClear"
      @keyup.native="handleKeyUp"
      @blur="handleBlur"
    />
    <transition
      name="el-zoom-in-top"
      @before-enter="handleMenuEnter"
      @after-leave="doDestroy"
    >
      <el-select-menu
        v-show="visible"
        ref="popper"
        :append-to-body="true"
      >
        <el-scrollbar
          v-show="list.length > 0"
          ref="scrollbar"
          tag="ul"
          wrap-class="el-select-dropdown__wrap"
          view-class="el-select-dropdown__list"
        >
          <el-li
            v-for="(item,index) in list"
            :key="item | getKey(keyVal,index)"
            :value="item[keyVal]"
            :label="item[label]"
            :item="item"
          />
        </el-scrollbar>
        <p
          v-show="list.length == 0"
          :style="{width:width+'px'}"
          class="el-select-dropdown__empty"
        >
          无数据
        </p>
      </el-select-menu>
    </transition>

  </div>
</template>

<script>
  import scrollIntoView from 'element-ui/src/utils/scroll-into-view';
  import {
    PopupManager
  } from 'element-ui/src/utils/popup';
  import ElSelectMenu from './select-dropdown.vue';
  import NavigationMixin from './navigation-mixin';
  import ElLi from './li.vue';
  import Emitter from '../../mixins/emitter';

  export default {
    name: 'remote-select-myself',
    componentName: 'mySelect',
    provide() {
      return {
        'select': this
      };
    },
    components: { ElSelectMenu, ElLi },
    filters: {
      getKey(item, keyVal, index) {
        return item[keyVal] + '_' + index.toString();
      }
    },
    mixins: [NavigationMixin, Emitter],
    model: {
      prop: 'value',
      event: 'input'
    },
    data() {
      return {
        popperAppendToBody: true,
        input: '',
        handleFocuse: '',
        timer: '',
        width: '',
        currentItem: {},
        list: [],
        visible: false,
        hoverIndex: -1,
        selected: '',
        cachedOptions: [],
        options: [],
        softFocus: false,
        focusByClear: false,
        // 标志是否要再去请求
        emitIfRequest: false,
        keyBeforeVal: '',
        getLabelByIdCan: true
      };
    },
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: String,
      placeholder: {
        type: String,
        default: '请输入内容'
      },
      needRequestImmediately: {
        type: Boolean,
        default: true
      },
      currentInputVal: {
        type: String,
        default: ''
      },
      id: {
        type: [String, Number],
        default: ''
      },
      requestUrl: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: 'txt'
      },
      keyVal: {
        type: String,
        default: 'value'
      },
      otherData: {
        type: Object,
        default: () => {
          return {};
        }
      },
      postName: {
        type: String,
        default: 'name'
      },
      clearable: {
        type: Boolean,
        default: false
      },
      postDataFilter: {
        type: Object,
        default: () => {
          return {};
        }
      },
      getLabelById: {
        type: Boolean,
        default: false
      },
      maxWidth: {
        type: String,
        default: '520'
      }
    },
    watch: {
      // 'otherData.guideType': {
      //   immediate: false,
      //   handler(newVal, oldVal) {
      //     this.handleRequest();
      //   }
      // },
      input: {
        immediate: false,
        handler(newVal, oldVal) {
          this.$emit('update:currentInputVal', newVal);
          if (newVal != oldVal && !this.emitIfRequest) {
            this.handleValueChange(newVal, oldVal);
          }
        }
      },
      value: {
        immediate: true,
        handler(v1, oldVal) {
          if (v1) {
            this.input = v1;
            this.currentItem[this.label] = v1;
            if (v1 && !oldVal) {
              this.handleValueChange(v1, '');
            }
          }
          if (this.id) {
            this.currentItem[this.keyVal] = this.id;
          }
        }
      },
      visible(v) {
        if (v) {
          this.doUpdate();
        } else {
          this.doDestroy();
        }
      }
    },
    mounted() {
      this.width = this.$refs.reference.$el.offsetWidth;
      this.$on('handleChoose', this.handleChoose);
      if (this.needRequestImmediately) {
        this.handleRequest();
      }
    },
    created() {
    },
    methods: {
      clearList() {
        this.list = [];
      },
      resetInputValAndNoRequest(v) {
        this.input = v;
        this.emitIfRequest = true;
      },
      handleKeyDown(event) {
        console.log(this.input);
        this.emitIfRequest = false;
        this.keyBeforeVal = this.input;
        if (event.code == 'Backspace') {
          this.currentItem = {};
          this.$emit('update:id', this.currentItem[this.keyVal] ? this.currentItem[this.keyVal] : '');
          this.scrollToOption();
        }
      },
      handleKeyUp() {
        if (this.keyBeforeVal != this.input) {
          this.currentItem = {};
          this.$emit('update:id', this.currentItem[this.keyVal] ? this.currentItem[this.keyVal] : '');
          this.scrollToOption();
        }
      },
      setValueEqualIndex(index) {
        // 设置返回数组第index项为选中项,必须用此方法,否则会触发请求
        this.currentItem = this.list[index];
        this.emitParent(true);
      },
      forceSetInputToRequest(v = '') {
        this.input = v;
      },
      doUpdate() {
        this.$refs.popper && this.$refs.popper.updatePopper();
      },
      doDestroy() {
        this.$refs.popper && this.$refs.popper.doDestroy();
        setTimeout(() => {
          this.emitIfRequest = false;
        }, 100);
      },
      onOptionDestroy(index) {
        if (index > -1) {
          this.cachedOptions.splice(index, 1);
        }
      },
      handleMenuEnter() {
        this.$nextTick(() => this.scrollToOption());
      },
      handleFocus() {
        if (PopupManager.zIndex < 6000) {
          PopupManager.zIndex = 6000;
        }
        this.emitIfRequest = false;
        if (this.readonly) {
          return;
        }
        setTimeout(() => {
          if (!this.softFocus && !this.focusByClear) {
            this.$refs.popper && this.$refs.popper.getWidth();
            this.$nextTick(() => this.scrollToOption());
            this.visible = true;
          } else {
            this.$refs.reference && this.$refs.reference.blur();
            this.softFocus = false;
            this.focusByClear = false;
          }
        }, 50);
      },
      handleBlur(event) {
        setTimeout(() => {
          console.log(Date.now(), /blur/);
          this.visible = false;
          this.$refs.reference && this.$refs.reference.blur();
        }, 250);
        this.softFocus = false;
      },
      handleClear() {
        this.currentItem = {};
        this.emitParent();
        this.scrollToOption();
        this.focusByClear = true;
        this.$refs.reference && this.$refs.reference.focus();
      },
      scrollToOption() {
        const target = this.cachedOptions.find(item => {
          return item.value == this.id;
        });
        console.log(this.id, target);
        if (this.$refs.popper) {
          let menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
          if (!target) {
            menu.scrollTop = 0;
          } else {
            scrollIntoView(menu, target.$el);
          }
        }
        this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
      },
      emitParent(byChoose) {
        // this.$emit('input', this.currentItem[this.label])
        this.emitIfRequest = byChoose;
        this.input = this.currentItem[this.label];
        console.log(this.currentItem, this.keyVal, this.currentItem[this.keyVal] ? this.currentItem[this.keyVal] : '');
        this.$emit('update:id', this.currentItem[this.keyVal] ? this.currentItem[this.keyVal] : '');
        this.$emit('change', this.currentItem);
      },
      handleRequest(v, firstTime) {
        let name = v;
        for (let key in this.postDataFilter) {
          if (key == this.postName) {
            if (v) {
              name = this.postDataFilter[key](v);
            }
          }
        }
        return new Promise((resolve) => {
          this.$axios({
            url: this.requestUrl,
            method: 'POST',
            data: {
              [this.postName]: name || '',
              ...this.otherData
            }
          }).then(res => {
            let arr;
            if (res.data && res.data.list) {
              arr = res.data.list;
            } else if (res.data) {
              arr = res.data;
            } else {
              arr = [];
            }
            this.list = Array.isArray(arr) ? [...arr] : [];
            this.$refs.popper && this.$refs.popper.doDestroy();
            if (this.getLabelById && this.id) {
              let item = this.list.find(item => {
                let inKey = (item[this.keyVal] + '').replace(/\s*/g, "");
                let outKey = (this.id + '').replace(/\s*/g, "");
                return inKey == outKey;
              });
              if (item) {
                this.input = item[this.label];
                this.emitIfRequest = true;
              }
            }
            this.$emit('requestSuccess', this.list, firstTime);
            this.$emit('beforeSearchString', name);
            this.$refs.popper && this.$refs.popper.updatePopper();
            resolve(arr);
          });
        });
      },
      handleChoose(options, item) {
        console.log(Date.now(), /choose/);
        this.currentItem = item;
        this.emitParent(true);
        setTimeout(() => {
          this.$refs.reference && this.$refs.reference.blur();
          this.visible = false;
        }, 150);
      },
      handleValueChange(newVal, oldVal, firstTime) {
        if (newVal != oldVal) {
          this.debounce(
            this.handleRequest,
            200,
            newVal,
            firstTime
          );
        }
      },
      debounce(fn, delay, v, firstTime) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          fn(v, firstTime);
        }, delay);
      }
    },
  };

</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/select/index.vue